import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_CHAT_ANSWER_BOT_NAME_230413 } from "@faire/web-api--source/indigofair/settings/HELP_CENTER_CHAT_ANSWER_BOT_NAME_230413";

export function getSettingChatAnswerBotName(): string {
  return getSettingValueWithoutAssignment(
    HELP_CENTER_CHAT_ANSWER_BOT_NAME_230413,
    "Answer Bot"
  );
}
